// extracted by mini-css-extract-plugin
module.exports = {"load-more":"PostList_load-more___cjCX","spaces-enabled-empty-state":"PostList_spaces-enabled-empty-state___Yqn4","is-home":"PostList_is-home__KAw78"};